import fetchApi from "../fetchApi";

// Returns the assignable-permission catalog: { permissions: { "category.feature": { id, read, write, delete } } }
export const GetPermissions = async () => {
  const options = {
    method: "GET",
    headers: new Headers({
      "Content-Type": "application/json",
    }),
    redirect: "follow",
  };

  return await fetchApi("permissions", options);
};
